<template>
  <v-container v-if="currentContact && teams[$route.params.team].account">
    <v-row>
      <v-col stretch>
        <v-breadcrumb :items="breadcrumbContactItems" :mobile="breadcrumbMobileItem"></v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <v-title-bar :title="$h.formatName(currentContact)" :label="$t('labels.createNewContact')">
          <v-button round secondary icon @click.native="$goTo('createContact')"
            ><v2-icon :data="require('@icon/Icon=plus.svg')" color="#fff"></v2-icon
          ></v-button>
        </v-title-bar>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 pb-0">
        <v-list-header simple>
          <v-list-header-cell
            :link="$t('actions.edit')"
            :route="{
              name: 'editContact',
              params: { uid: currentContact.uid },
            }"
          />
        </v-list-header>
      </v-col>
      <v-col class="col col-12 sm:col-6">
        <v-list-header simple>
          <v-list-header-cell :title="$t('labels.contactData')" />
        </v-list-header>
        <ul class="list">
          <v-list-item simple>
            <v-list-cell :title="$t('contact.gender')" />
            <v-list-cell :value="$h.formatGender(currentContact.gender)" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.name')" />
            <v-list-cell :value="$h.formatName(currentContact)" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.email')" />
            <v-list-cell :value="currentContact.email" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.tel')" />
            <v-list-cell :value="currentContact.tel" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.mobile')" />
            <v-list-cell :value="currentContact.mobile" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.fax')" />
            <v-list-cell :value="currentContact.fax" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.address')" />
            <v-list-cell :value="$h.formatAddress(currentContact)" size="2" />
          </v-list-item>
        </ul>
      </v-col>
      <v-col class="col col-12 sm:col-6">
        <v-list-header simple>
          <v-list-header-cell :title="$t('labels.contactImage')" />
        </v-list-header>
        <v-list-item simple flexibleHeight>
          <v-list-cell size="1">
            <div slot="value" class="w-full flex justify-center">
              <div v-if="currentContact.image">
                <v-spinner :loading="!isReady" style="width: auto; height: auto"></v-spinner>
              </div>
              <v-lazy-load v-if="isReady" :image="imageUrl" placeholderFileName="defaultContact"></v-lazy-load>
              <span v-if="!currentContact.image">{{ $t("placeholders.noImageSelected") }}</span>
            </div>
          </v-list-cell>
        </v-list-item>
        <div v-if="currentContact.image">
          {{ $t("stati.files.text." + currentStatus) }}
        </div>
      </v-col>
      <v-col class="col col-12 sm:col-6">
        <v-list-header simple>
          <v-list-header-cell :title="$t('labels.contactCompanyInfo')" />
        </v-list-header>
        <ul class="list">
          <v-list-item simple>
            <v-list-cell :title="$t('contact.company')" />
            <v-list-cell :value="currentContact.company" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.jobTitle')" />
            <v-list-cell :value="currentContact.job_title" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.jobUnit')" />
            <v-list-cell :value="currentContact.job_unit" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.website')" />
            <v-list-cell :value="currentContact.website" size="2" />
          </v-list-item>
        </ul>
      </v-col>
      <v-col class="col col-12 sm:col-6">
        <v-list-header simple>
          <v-list-header-cell :title="$t('labels.contactTimeAndLang')" />
        </v-list-header>
        <ul class="list">
          <v-list-item simple>
            <v-list-cell :title="$t('contact.locale')" />
            <v-list-cell :value="$h.formatLocale(currentContact)" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.timezone')" />
            <v-list-cell :value="$h.formatTimezone(currentContact.timezone)" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.created_at')" />
            <v-list-cell
              :value="$h.formatDate(currentContact.created_at, teams[$route.params.team].account.timezone)"
              size="2"
            />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('contact.updated_at')" />
            <v-list-cell
              :value="$h.formatDate(currentContact.updated_at, teams[$route.params.team].account.timezone)"
              size="2"
            />
          </v-list-item>
        </ul>
      </v-col>
      <v-col class="col col-12 sm:col-6">
        <v-list-header simple>
          <v-list-header-cell :title="$t('labels.contactSocialMediaAccounts')" />
        </v-list-header>
        <ul class="list">
          <v-list-item simple v-for="(value, key) in currentContact.social_media_accounts" :key="key">
            <v-list-cell :title="key" class="capitalize" />
            <v-list-cell :value="value" size="2" />
          </v-list-item>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Contact",
  data() {
    return {
      amountTry: 10,
      timeWaitStart: 3000,
      timer: null,
      currentProfileImage: {},
      imageUrl: "",
      breadcrumbContactItems: [
        {
          label: this.$t("menus.settings"),
          route: { name: "Settings", params: { tab: "account" } },
        },
        {
          label: this.$t("menus.contacts"),
          route: { name: "Settings", params: { tab: "contacts" } },
        },
      ],
      breadcrumbMobileItem: {
        label: this.$t("menus.contacts"),
        route: { name: "Settings", params: { tab: "contacts" } },
      },
    };
  },
  created() {
    this.loadPageData(this.$route.params.uid);
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    ...mapActions(["getContact", "getContactImagePreview"]),
    loadPageData(uid) {
      const vm = this;
      vm.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
      vm.getContact({ contact: uid }).then((res) => {
        vm.currentProfileImage = res.image;
        vm.breadcrumbContactItems.push({
          label: vm.$h.formatName(vm.currentContact),
          active: true,
        });
        vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        this.untilReady();
      });
    },
    isConvertedCalculate(item) {
      return this.statiBits && item ? this.$h.globalIsBitSet(item.status, this.statiBits.CONVERTED.bit) : false;
    },
    isReadyCalculate(item) {
      if (this.statiBits && item) {
        console.log("IS READY", this.$h.globalCheckFileStatus(item.status, this.statiBits));
        return (
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "VIRUS_SCANNING" &&
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "CONVERTING"
        );
      } else {
        return false;
      }
    },
    isDownloadableCalculate(item) {
      return this.statiBits && item
        ? this.$h.globalIsBitSet(item.status, this.statiBits.VIRUS_SCAN_RESULT_OK.bit) ||
            this.$h.globalIsBitSet(item.status, this.statiBits.VIRUS_SCAN_RESULT_NA.bit)
        : false;
    },
    getItemPreview() {
      const vm = this;
      if (vm.isConverted) {
        vm.getContactImagePreview({
          customLoading: true,
          file: vm.currentContact.image.uid,
          contact: vm.currentContact.uid,
          width: "100",
          height: "100",
        })
          .then((res) => {
            vm.imageUrl = res;
          })
          .catch(() => {});
      } else {
        vm.imageUrl = "";
      }
    },
    untilReady() {
      if (this.currentProfileImage) {
        this.getItemPreview();
        const data = {
          contact: this.currentContact.uid,
        };
        if (!this.isReady) {
          const vm = this;
          vm.timer = setTimeout(function () {
            vm.getContact(data)
              .then((response) => {
                vm.currentProfileImage = response.image;
                vm.amountTry = vm.amountTry - 1;
                if (vm.amountTry <= 0) {
                  vm.amountTry = 10;
                  vm.timeWaitStart = vm.timeWaitStart + 60000;
                }
                vm.untilReady();
              })
              .catch();
          }, vm.timeWaitStart);
        }
      }
    },
  },
  computed: {
    isConverted() {
      return this.isConvertedCalculate(this.currentProfileImage);
    },
    isReady() {
      return this.isReadyCalculate(this.currentProfileImage);
    },
    isDisabled() {
      return !this.isDownloadable;
    },
    isDownloadable() {
      return this.isDownloadableCalculate(this.currentProfileImage);
    },
    currentStatus() {
      return this.statiBits && this.currentProfileImage
        ? this.$h.globalGetCurrentFileStatus(this.currentProfileImage.status, this.statiBits)
        : "";
    },
    ...mapGetters({
      teams: "auth_get_teams",
      currentContact: "teams_get_current_contact",
      statiBits: "global_get_fileStatiBits",
    }),
  },
};
</script>
